import classNames from "classnames";
import { CustomButton2, UserInformation } from "../../components";
import utils from "../../utils";
import "./index.scss";
type Props = {
  role?: string;
  loading?: boolean;
  open: boolean;
  onClose: () => void;
  user?: any;
  data?: any;
  onSubmit?: (userId: string) => void;
};

const DeleteModal = ({
  open,
  role,
  onClose,
  loading,
  user,
  data,
  onSubmit,
}: //  onSubmit
Props) => {
  if (!open) return null;
  return (
    <section onClick={onClose} id="d-overly">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={classNames("dm-container", {
          "scale-in-center": open,
          "scale-out-center": !open,
        })}
      >
        <div className="dm-header">
          <i className="fa-solid fa-xmark closeBtn" onClick={onClose}></i>
        </div>
        <div className="dm-body">
          {user && user.firstName && user.lastName ? (
            <UserInformation
              role={role}
              isBlock={user.blocks?.length > 0}
              avatar={user.avatar}
              name={user.firstName + " " + user.lastName}
              phoneNumber={"0" + utils.hyphenfyMobileNumber(user.phoneNumber)}
            />
          ) : null}
          {data ? (
            <div className="dm-body-description">
              {" "}
              آیا از حذف اطمینان دارید؟{" "}
            </div>
          ) : (
            <div className="dm-body-description">
              آیا از حذف کاربر مورد نظر اطمینان دارید؟
            </div>
          )}
          <div className="dm-buttons-wrapper">
            <CustomButton2
              isLoading={loading}
              title="تایید"
              onClick={() =>
                onSubmit && onSubmit(user?._id ? user._id : data._id)
              }
              type="primary"
            />
            <CustomButton2
              isLoading={loading}
              title="لغو"
              onClick={(event: any) => onClose()}
              type="danger"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeleteModal;

